<script setup>
import { STitle } from '@n966/soilbox_ui'
import { getAssetsSrc } from '@/utils'

defineProps({
  config: {
    type: Object,
    default: null
  }
})
</script>

<template>
  <div
    class="updates-comp"
    v-if="config"
  >
    <img
      v-if="config?.image"
      class="updates-comp__asset-wrapper"
      :src="getAssetsSrc(`assets/images/updates/${config.image}`)"
      alt=""
    />

    <video
      v-if="config?.video"
      class="updates-comp__asset-wrapper"
      autoplay
      loop
      muted
      playsinline
    >
      <source
        :src="getAssetsSrc(`assets/videos/${config.video}`)"
        type="video/mp4"
      />
    </video>

    <div class="updates-comp__text-wrapper">
      <div class="updates-comp__block">
        <s-title
          v-if="config?.title"
          type="title"
        >
          {{ config?.title }}
        </s-title>
        <div v-if="config?.descriptions?.length">
          <p
            v-for="item in config.descriptions"
            :key="item"
            v-html="item.text"
          />
        </div>
        <ul
          v-if="config?.list?.length"
          class="updates-comp__block-comp"
        >
          <li
            v-for="item in config.list"
            :key="item"
            v-html="item.text"
          />
        </ul>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.updates-comp {
  display: flex;
  flex-direction: column;
  gap: 1rem;

  &-feedback {
    &-title {
      margin-bottom: 4px;
    }
  }

  &__block {
    display: flex;
    flex-direction: column;
    gap: 12px;

    color: var(--text);
    font-size: 0.875rem;
    margin: 0;

    &-comp {
      color: var(--text);
      font-size: 0.875rem;
      margin: 0;

      & li {
        margin-bottom: 8px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    &-text {
      line-height: 1.5;

      &_bold {
        font-weight: 700;
      }
    }

    & span {
      font-weight: 700;
    }
  }

  &__asset-wrapper {
    border: 1px solid var(--main-bg);
    border-radius: 8px;
    width: 100%;
  }

  &__text-wrapper {
    display: flex;
    flex-direction: column;
    gap: 32px;
  }
}
</style>
